import _styled from "@emotion/styled/base";
import { createElement, Fragment } from "@wordpress/element";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/**
 * External dependencies
 */

/**
 * WordPress dependencies
 */
import { __experimentalToolsPanelItem as ToolsPanelItem, __experimentalUnitControl as UnitControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
const SingleColumnToolsPanelItem = /*#__PURE__*/_styled(ToolsPanelItem, process.env.NODE_ENV === "production" ? {
  target: "ef8pe3d0"
} : {
  target: "ef8pe3d0",
  label: "SingleColumnToolsPanelItem"
})(process.env.NODE_ENV === "production" ? {
  name: "957xgf",
  styles: "grid-column:span 1"
} : {
  name: "957xgf",
  styles: "grid-column:span 1",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

/**
 * @typedef {import('@wordpress/components/build-types/unit-control/types').WPUnitControlUnit} WPUnitControlUnit
 */

/**
 * @typedef {Object} WidthHeightToolValue
 * @property {string} [width]  Width CSS value.
 * @property {string} [height] Height CSS value.
 */

/**
 * @callback WidthHeightToolOnChange
 * @param {WidthHeightToolValue} nextValue Next dimensions value.
 * @return {void}
 */

/**
 * @typedef {Object} WidthHeightToolProps
 * @property {string}                  [panelId]          ID of the panel that contains the controls.
 * @property {WidthHeightToolValue}    [value]            Current dimensions values.
 * @property {WidthHeightToolOnChange} [onChange]         Callback to update the dimensions values.
 * @property {WPUnitControlUnit[]}     [units]            Units options.
 * @property {boolean}                 [isShownByDefault] Whether the panel is shown by default.
 */

/**
 * Component that renders controls to edit the dimensions of an image or container.
 *
 * @param {WidthHeightToolProps} props The component props.
 *
 * @return {import('@wordpress/element').WPElement} The width and height tool.
 */
export default function WidthHeightTool({
  panelId,
  value = {},
  onChange = () => {},
  units,
  isShownByDefault = true
}) {
  var _value$width, _value$height;
  // null, undefined, and 'auto' all represent the default value.
  const width = value.width === 'auto' ? '' : (_value$width = value.width) !== null && _value$width !== void 0 ? _value$width : '';
  const height = value.height === 'auto' ? '' : (_value$height = value.height) !== null && _value$height !== void 0 ? _value$height : '';
  const onDimensionChange = dimension => nextDimension => {
    const nextValue = {
      ...value
    };
    // Empty strings or undefined may be passed and both represent removing the value.
    if (!nextDimension) {
      delete nextValue[dimension];
    } else {
      nextValue[dimension] = nextDimension;
    }
    onChange(nextValue);
  };
  return createElement(Fragment, null, createElement(SingleColumnToolsPanelItem, {
    label: __('Width'),
    isShownByDefault: isShownByDefault,
    hasValue: () => width !== '',
    onDeselect: onDimensionChange('width'),
    panelId: panelId
  }, createElement(UnitControl, {
    label: __('Width'),
    placeholder: __('Auto'),
    labelPosition: "top",
    units: units,
    min: 0,
    value: width,
    onChange: onDimensionChange('width'),
    size: '__unstable-large'
  })), createElement(SingleColumnToolsPanelItem, {
    label: __('Height'),
    isShownByDefault: isShownByDefault,
    hasValue: () => height !== '',
    onDeselect: onDimensionChange('height'),
    panelId: panelId
  }, createElement(UnitControl, {
    label: __('Height'),
    placeholder: __('Auto'),
    labelPosition: "top",
    units: units,
    min: 0,
    value: height,
    onChange: onDimensionChange('height'),
    size: '__unstable-large'
  })));
}
//# sourceMappingURL=width-height-tool.js.map